import { render, staticRenderFns } from "./TransfersStatistics.vue?vue&type=template&id=102aff14&"
import script from "./TransfersStatistics.vue?vue&type=script&lang=js&"
export * from "./TransfersStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports